import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=fd237870&"
import script from "./InviteForm.vue?vue&type=script&lang=ts&"
export * from "./InviteForm.vue?vue&type=script&lang=ts&"
import style0 from "./InviteForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports